import { render, staticRenderFns } from "./BgRow.vue?vue&type=template&id=58a18c32&scoped=true&"
import script from "./BgRow.vue?vue&type=script&lang=js&"
export * from "./BgRow.vue?vue&type=script&lang=js&"
import style0 from "./BgRow.vue?vue&type=style&index=0&id=58a18c32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a18c32",
  null
  
)

export default component.exports